<template>
  <div>
    <v-icon title="Exportação para Excel" dark @click="abrirDialog()">$Excel</v-icon>

    <SysDialog
      v-model="dialog"
      titulo="Exportação para Excel"
      @click:primary="exportarExcel()"
      :largura="400"
      txtBotao="Exportar"
    >
      <v-menu
        ref="menu_data_inicial"
        v-model="menu_data_inicial"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dados_formatados.data_inicial"
            label="Data Inicial"
            append-icon="mdi-calendar"
            v-bind="attrs"
            v-on="on"
            outlined
            readonly
            :error-messages="DATA_INICIAL_ERRORS"
            @input="$v.dados.data_inicial.$touch()"
            @blur="$v.dados.data_inicial.$touch()"
          ></v-text-field>
        </template>

        <v-date-picker
          v-model="dados.data_inicial"
          @input="menu_data_inicial = false"
          no-title
          scrollable
        />
      </v-menu>

      <v-menu
        ref="menu_data_final"
        v-model="menu_data_final"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dados_formatados.data_final"
            label="Data Final"
            append-icon="mdi-calendar"
            v-bind="attrs"
            v-on="on"
            outlined
            readonly
            class="mb-n4"
            :error-messages="DATA_FINAL_ERRORS"
            @input="$v.dados.data_final.$touch()"
            @blur="$v.dados.data_final.$touch()"
          ></v-text-field>
        </template>

        <v-date-picker
          v-model="dados.data_final"
          @input="menu_data_final = false"
          no-title
          scrollable
        />
      </v-menu>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import $axios from '@/api/api.js'

export default {
  components: { SysDialog },
  props: {
    filtros: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    menu_data_inicial: false,
    menu_data_final: false,
    dados: {
      data_inicial: moment().startOf('month').format('YYYY-MM-DD'),
      data_final: moment().endOf('month').format('YYYY-MM-DD')
    },
    dados_formatados: {
      data_inicial: moment().startOf('month').format('DD/MM/YYYY'),
      data_final: moment().endOf('month').format('DD/MM/YYYY')
    }
  }),
  computed: {
    DATA_INICIAL_ERRORS() {
      const errors = [];
      if (!this.$v.dados.data_inicial.$dirty) return errors;
      !this.$v.dados.data_inicial.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    DATA_FINAL_ERRORS() {
      const errors = [];
      if (!this.$v.dados.data_final.$dirty) return errors;
      !this.$v.dados.data_final.required && errors.push("Campo Obrigatório.");
      return errors;
    }
  },
  watch: {
    "dados.data_inicial"(valor) {
      this.dados_formatados.data_inicial = moment(valor).format('DD/MM/YYYY');
    },
    "dados.data_final"(valor) {
      this.dados_formatados.data_final = moment(valor).format('DD/MM/YYYY');
    },
    "filtros.referencia"(valor) {
      this.dados.data_inicial = moment(valor, 'M/YYYY').startOf('month').format('YYYY-MM-DD');
      this.dados.data_final = moment(valor, 'M/YYYY').endOf('month').format('YYYY-MM-DD');
    }
  },
  methods: {
    abrirDialog() {
      this.dialog = true;
    },
    fecharDialog() {
      this.dialog = false;
    },
    exportarExcel() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const url = $axios.defaults.baseURL
        + '/relatorios/detalhes-do-produto/excel-detalhamento-das-vendas?'
        + `grupo=${this.filtros.grupo}`
        + `&filial=${this.filtros.filialCompra}`
        + `&produto=${this.filtros.produto}`
        + `&data_inicial=${this.dados.data_inicial}`
        + `&data_final=${this.dados.data_final}`;

      this.fecharDialog();

      window.open(url, "_blank");
    }
  },
  validations: {
    dados: {
      data_inicial: { required },
      data_final: { required }
    }
  }
}
</script>

<style>

</style>
